import * as React from "react"

const MOBILE_BREAKPOINT = 768

/**
 * True on viewports narrower than the `md` breakpoint.
 *
 * The initial value is read synchronously rather than settled in an effect.
 * Starting at `undefined` meant the first render always claimed "desktop" and
 * corrected itself a tick later, which is invisible for a CSS class but not for
 * anything a component only reads once: ResizablePanel captures `defaultSize`
 * on mount, so the workspace's mobile split was recorded at the desktop value
 * and the chat band came out at 26% of the screen instead of 45%.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(
    // Guarded for any non-browser render; the effect below corrects it anyway.
    () => (typeof window === "undefined" ? false : window.innerWidth < MOBILE_BREAKPOINT)
  )

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange);
  }, [])

  return !!isMobile
}
